<template>
  <div class="component-wrapper d-flex flex-column align-center breadcrumb">
    <div class="d-flex mt-5 mb-11 btn-container">
      <v-btn
        class="success rounded button text-sm-body-1 font-weight-regular ml-auto"
        @click="onNewReport"
      >
        <div class="d-flex align-center">
          <v-icon color="white">mdi-plus</v-icon>
          <span class="ml-1">Νέα έκθεση</span>
        </div>
      </v-btn>
    </div>

    <v-progress-circular
      color="primary"
      v-if="loader"
      indeterminate
    ></v-progress-circular>

    <v-data-table
      v-else
      :headers="headers"
      :items="reports"
      :items-per-page="10"
      class="elevation-1 table"
      :loading="tableLoader"
      width="100%"
    >
      <template v-slot:[`item.uploadedToHCMCDate`]="{ item }">
        <div class="body-2">
          {{ new Date(item.uploadedToHCMCDate).toLocaleDateString("el") }}
          {{
            padTo2Digits(new Date(item.uploadedToHCMCDate).getHours()) +
            ":" +
            padTo2Digits(new Date(item.uploadedToHCMCDate).getMinutes())
          }}
        </div>
      </template>

      <template v-slot:[`item.submissionStatus`]="{ item }">
        <div class="body-2">
          <div v-if="item.submissionStatus == 'acceptedByESMA'">
            Αποδεκτή από ESMA
          </div>

          <div v-if="item.submissionStatus == 'pending'">
            Δεν έχει υποβληθεί στην Ε.Κ.
          </div>

          <div
            v-if="
              item.submissionStatus == 'submittedToHCMC' ||
              item.submissionStatus == 'submittedToESMA'
            "
          >
            Εκκρεμεί απάντηση από την ESMA
          </div>

          <div v-if="item.submissionStatus == 'returnedByHCMC'">
            Απαιτούνται διορθώσεις πριν την υποβολή στην ESMA <br />
            <span class="text-caption">
              ({{ item.lastValidationMessage }})
            </span>
          </div>

          <div v-if="item.submissionStatus == 'returnedByESMA'">
            Απορρίφθηκε από την ESMA
            <span class="text-caption">
              ({{ item.lastValidationMessage }})
            </span>
          </div>
        </div>
      </template>

      <template v-slot:[`item.creditInstituteName`]="{ item }">
        <div class="body-2">
          {{
            item.creditInstituteName.length > 50
              ? item.creditInstituteName.substring(0, 30) + "..."
              : item.creditInstituteName
          }}
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex">
          <v-btn class="primary rounded body-2 mr-2" @click="onSave(item)"
            >Λήψη XML</v-btn
          >
          <v-btn
            class="primary rounded body-2 mr-2"
            @click="onDownloadPdf(item)"
          >
            Λήψη PDF
          </v-btn>
          <!-- <v-btn class="primary rounded body-2 mr-2" @click="onShow(item)"
            >Προβολή XML</v-btn
          > -->

          <v-btn
            v-if="item.submissionStatus == 'pending'"
            class="success rounded body-2 mr-2"
            @click="onSubmit(item)"
            >Υποβολή στην Ε.Κ.</v-btn
          >
        </div>
      </template>
    </v-data-table>
    <v-dialog min-width="auto" v-model="dialog">
      <ShowReport v-if="dialog" />
    </v-dialog>

    <v-dialog min-width="auto" v-model="changePasswordDialog" persistent>
      <ChangeOwnPassword
        v-if="changePasswordDialog"
        @close="setUserMustChangePassword(false)"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ShowReport from "@/components/Modals/ShowReport.vue";
import ChangeOwnPassword from "@/components/Modals/ChangeOwnPassword.vue";
import axios from "axios";

export default {
  components: {
    ShowReport,
    ChangeOwnPassword,
  },

  async created() {
    console.log("userMustChangePassword", this.changePasswordDialog);
    this.tableLoader = true;
    await this.getReports();
    this.tableLoader = false;

    this.loader = false;
  },

  data() {
    return {
      tableLoader: false,
      page: 1,
      loader: true,
      buttonLoader: false,
      alert: false,
      alertR: false,
      alertItems: {},
      alertItemsR: {},
      headers: [
        {
          text: "Υποβολή στην ΕΚ",
          sortable: false,
          value: "uploadedToHCMCDate",
          width: "150px",
        },

        {
          text: "Υποβάλων από ΑΕΔΑΚ",
          sortable: false,
          value: "uploadedToHCMCBy",
          width: "100px",
        },

        {
          text: "Κατάσταση",
          sortable: false,
          value: "submissionStatus",
          width: "300px",
        },

        {
          text: "Επιλογές",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      reports: (state) => state.reports.reports,
      currentReport: (state) => state.reports.currentReport,
      pendingReports: (state) => state.reports.pendingReports,
      currentId: (state) => state.reports.currentId,
      totalPageCount: (state) => state.reports.totalPageCount,
      openPeriodsToEnd: (state) => state.periods.openPeriodsToEnd,
      savedReport: (state) => state.reports.savedReport,
    }),

    dialog: {
      get() {
        return this.$store.state.dialogs.showReportDialog;
      },
      set(value) {
        return this.updateShowReportDialog(value);
      },
    },

    changePasswordDialog: {
      get() {
        return this.$store.state.auth.userMustChangePassword;
      },
      set(value) {
        return this.setUserMustChangePassword(value);
      },
    },
  },

  methods: {
    ...mapMutations([
      "setCurrentReport",
      "setCurrentRoute",
      "setCurrentReportVersion",
      "updateShowReportDialog",
      "setUserMustChangePassword",
    ]),
    ...mapActions([
      "getReports",
      "getPendingReports",
      "getEndingPeriodReminder",
      "getSavedReport",
      "submitReport",
    ]),

    async onDownloadPdf(report) {
      try {
        const result = await axios({
          method: "get",
          url: `${process.env.VUE_APP_BASE_URL}/report/ExportSingleToPdf/${report.submittedVersionId}`,
          responseType: "arraybuffer",
        });

        const savedReport = result;

        const filename = savedReport.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(new Blob([savedReport.data]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch {}
    },

    padTo2Digits(num) {
      return String(num).padStart(2, "0");
    },

    onView(id) {
      this.setCurrentRoute("view");
      this.setCurrentReport(id);
      this.$router.push(`/employees/report/${id}/details`);
    },

    onNewReport() {
      this.setCurrentRoute("new");
      this.$router.push("/employees/new/report");
    },

    async onSave(report) {
      try {
        await this.getSavedReport(report.lastUploadedVersionId);

        const filename = this.savedReport.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(
          new Blob([this.savedReport.data])
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch {}
    },

    onShow(item) {
      this.setCurrentReport(item);

      this.setCurrentReportVersion(item);
      this.updateShowReportDialog(true);
    },

    async onSubmit(item) {
      try {
        this.tableLoader = true;
        await this.submitReport(item.lastUploadedVersionId);
        await this.getReports();

        this.tableLoader = false;
      } catch {
        this.tableLoader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb {
  width: 100%;
}

.container,
.btn-container,
.table {
  width: 100%;
}
</style>